/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupBody
 */
export interface GroupBody {
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the GroupBody interface.
 */
export function instanceOfGroupBody(value: object): value is GroupBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GroupBodyFromJSON(json: any): GroupBody {
    return GroupBodyFromJSONTyped(json, false);
}

export function GroupBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function GroupBodyToJSON(json: any): GroupBody {
    return GroupBodyToJSONTyped(json, false);
}

export function GroupBodyToJSONTyped(value?: GroupBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

